
// Create a flag to track localization form submission
let localizationSubmitted = false;

// Declare the observer variable outside of the DOMContentLoaded event to
// make it accessible to other functions
let observer;

window.addEventListener("DOMContentLoaded", (event) => {
    const localizationForm = document.querySelector("#FooterCountryForm");
    const countryCodeInput = localizationForm.querySelector(
        'input[name="country_code"]'
    );

    // Add event listener to an existing or future checkout form
    const addCheckoutFormSubmitEventListener = (checkoutForm) => {
        if (checkoutForm._listenerAdded) return; // Exit if the listener was already added

        checkoutForm.addEventListener("submit", async (e) => {
            if (localizationSubmitted) {
                return;
            }

            e.preventDefault();

            const countryResponse = await fetch(
                window.Shopify.routes.root +
                "browsing_context_suggestions.json" +
                "?country[enabled]=true" +
                `&country[exclude]=${window.Shopify.country}` +
                "&language[enabled]=true" +
                `&language[exclude]=${window.Shopify.language}`
            );

            const data = await countryResponse.json();

            // Get the detected country
            const detectedCountry = data.detected_values.country.handle;

            // let eurListItem = [
            //     ...document.querySelectorAll(".disclosure__item"),
            // ].find((item) => {
            //     return item.textContent.includes("EUR");
            // });

            // let eurValue = eurListItem.querySelector("a").dataset.value;

            countryCodeInput.value = detectedCountry;

            console.log("countryCodeInput.value", countryCodeInput.value);

            let formData = new FormData(localizationForm);

            let response = await fetch(localizationForm.action, {
                method: "POST",
                body: formData,
            });

            console.log("Fetch response:", response);
            console.log("Fetch response status:", response.status);

            localStorage.removeItem("lastUpdated");

            if (response.ok) {
                console.log("Localization form submission success: ", response);
                localizationSubmitted = true;
                observer.disconnect(); // Disconnect the observer here
                window.location.href = "/checkout";
            } else {
                console.log("Localization form submission failed: ", response);
            }
        });

        checkoutForm._listenerAdded = true; // Mark the listener as added on the form element itself
    };

    // Set up a mutation observer
    observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                let checkoutButton = document.querySelector(
                    "#CartDrawer-Checkout"
                );

                if (checkoutButton && !checkoutButton.form._listenerAdded) {
                    addCheckoutFormSubmitEventListener(checkoutButton.form);
                }
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Check if the button already exists at the time of script execution
    let checkoutButton = document.querySelector("#CartDrawer-Checkout");
    if (checkoutButton && !checkoutButton.form._listenerAdded) {
        addCheckoutFormSubmitEventListener(checkoutButton.form);
    }
});

// Create a flag to track localization form submission
// let localizationSubmitted = false;

// window.addEventListener("DOMContentLoaded", (event) => {
//     const localizationForm = document.querySelector("#FooterCountryForm");
//     const countryCodeInput = localizationForm.querySelector(
//         'input[name="country_code"]'
//     );

//     // Add event listener to an existing or future checkout button
//     const addCheckoutButtonEventListener = (checkoutButton) => {
//         checkoutButton.addEventListener("click", async (e) => {
//             if (localizationSubmitted) {
//                 return;
//             }

//             e.preventDefault();

//             let eurListItem = [
//                 ...document.querySelectorAll(".disclosure__item"),
//             ].find((item) => {
//                 return item.textContent.includes("EUR");
//             });

//             let eurValue = eurListItem.querySelector("a").dataset.value;

//             countryCodeInput.value = eurValue;

//             let formData = new FormData(localizationForm);

//             let response = await fetch(localizationForm.action, {
//                 method: "POST",
//                 body: formData,
//             });

//             localStorage.removeItem("lastUpdated");

//             if (response.ok) {
//                 console.log("Localization form submission success: ", response);
//                 localizationSubmitted = true;
//                 checkoutButton.click();
//             } else {
//                 console.log("Localization form submission failed: ", response);
//             }
//         });
//     };

//     // Set up a mutation observer
//     const observer = new MutationObserver((mutationsList, observer) => {
//         for (let mutation of mutationsList) {
//             if (mutation.type === "childList") {
//                 let checkoutButton = document.querySelector(
//                     "#CartDrawer-Checkout"
//                 );
//                 if (checkoutButton) {
//                     addCheckoutButtonEventListener(checkoutButton);
//                     // observer.disconnect(); // Stop observing after we found the button
//                 }
//             }
//         }
//     });

//     // Start observing the document with the configured parameters
//     observer.observe(document.body, { childList: true, subtree: true });

//     // Check if the button already exists at the time of script execution
//     let checkoutButton = document.querySelector("#CartDrawer-Checkout");
//     if (checkoutButton) {
//         addCheckoutButtonEventListener(checkoutButton);
//     }
// });

// On Cart Page
// Create a flag to track localization form submission
let localizationSubmittedCart = false;

window.addEventListener("DOMContentLoaded", (event) => {
    const localizationForm = document.querySelector("#FooterCountryForm");
    const countryCodeInput = localizationForm.querySelector(
        'input[name="country_code"]'
    );

    // Add event listener to an existing or future checkout form
    const addCheckoutFormSubmitEventListener = (checkoutForm) => {
        checkoutForm.addEventListener("submit", async (e) => {
            if (localizationSubmittedCart) {
                return;
            }

            e.preventDefault();

            const countryResponse = await fetch(
                window.Shopify.routes.root +
                "browsing_context_suggestions.json" +
                "?country[enabled]=true" +
                `&country[exclude]=${window.Shopify.country}` +
                "&language[enabled]=true" +
                `&language[exclude]=${window.Shopify.language}`
            );

            const data = await countryResponse.json();

            // Get the detected country
            const detectedCountry = data.detected_values.country.handle;

            // let eurListItem = [
            //     ...document.querySelectorAll(".disclosure__item"),
            // ].find((item) => {
            //     return item.textContent.includes("EUR");
            // });

            // let eurValue = eurListItem.querySelector("a").dataset.value;

            countryCodeInput.value = detectedCountry;

            console.log("countryCodeInput.value", countryCodeInput.value);

            let formData = new FormData(localizationForm);

            let response = await fetch(localizationForm.action, {
                method: "POST",
                body: formData,
            });

            console.log("Fetch response:", response);
            console.log("Fetch response status:", response.status);

            localStorage.removeItem("lastUpdated");

            if (response.ok) {
                console.log("Localization form submission success: ", response);
                localizationSubmittedCart = true;
                window.location.href = "/checkout"; // Redirect to /checkout
            } else {
                console.log("Localization form submission failed: ", response);
            }
        });
    };

    // Set up a mutation observer
    const observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                let checkoutButton = document.querySelector("#checkout");
                if (checkoutButton) {
                    addCheckoutFormSubmitEventListener(checkoutButton.form);
                    observer.disconnect(); // Stop observing after we found the button
                }
            }
        }
    });

    // Start observing the document with the configured parameters
    observer.observe(document.body, { childList: true, subtree: true });

    // Check if the button already exists at the time of script execution
    let checkoutButton = document.querySelector("#checkout");
    if (checkoutButton) {
        addCheckoutFormSubmitEventListener(checkoutButton.form);
    }
});

// Function to check if the current user agent is a bot
function isBot() {
    const botPatterns = [
        'googlebot', 'bingbot', 'yandexbot', 'duckduckbot', 'slurp',
        'baiduspider', 'facebookexternalhit', 'twitterbot', 'rogerbot',
        'linkedinbot', 'embedly', 'quora link preview', 'showyoubot',
        'outbrain', 'pinterest', 'slackbot', 'vkShare', 'W3C_Validator'
    ];
    const userAgent = navigator.userAgent.toLowerCase();
    return botPatterns.some(bot => userAgent.includes(bot));
}

// Function to check if the request is from PageSpeed Insights
function isPageSpeedInsights() {
    return 'Chrome-Lighthouse' in window;
}

// Update location
async function getDetectedLocalizationAndSubmit() {
    // Exit early if the user agent is a bot
    if (isBot() || isPageSpeedInsights()) return;

    const lastUpdated = localStorage.getItem("lastUpdated");

    const currentDate = new Date().setHours(0, 0, 0, 0);

    // If the script was never run, or it was last run on a different day
    if (
        !lastUpdated ||
        new Date(lastUpdated).setHours(0, 0, 0, 0) < currentDate
    ) {
        const response = await fetch(
            window.Shopify.routes.root +
            "browsing_context_suggestions.json" +
            "?country[enabled]=true" +
            `&country[exclude]=${window.Shopify.country}` +
            "&language[enabled]=true" +
            `&language[exclude]=${window.Shopify.language}`
        );

        const data = await response.json();

        // Get the detected country
        const detectedCountry = data.detected_values.country.handle;

        // Set language to English
        const language = "en";

        // console.log(detectedCountry, detectedCountry != "ES");

        updateLocalization({ country: detectedCountry, language: language });

        // Save the current date to localStorage
        localStorage.setItem("lastUpdated", new Date());
    }
}

function updateLocalization({ country, language }) {
    const formId = crypto.randomUUID();
    const currentUrl = window.location.href; // Get the current URL
    const formHtml = `
    <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="country_code" value="${country}">
      <input name="language_code" value="${language}">
      <input name="return_to" value="${currentUrl}"> <!-- Add a redirect field with the current URL -->
    </form>
  `;
    document.body.insertAdjacentHTML("beforeend", formHtml);
    document.getElementById(formId).submit();
}

getDetectedLocalizationAndSubmit();